import React from "react";
import { MdContactPhone } from "react-icons/md";
import ContactTable from "./shared/ContactTable";

/**
 * @param {Object} props
 * @param {Array} props.contactCards - List of artist booking contact cards
 * @returns {React.ReactElement} Table of contacted artists with details drawer
 */
function BookingContactList({ contactCards }) {
    return (
        <ContactTable
            contactCards={contactCards}
            title="Artistes contact\u00e9s"
            nameField="artist_name"
            headerLabel="Artiste"
            emptyText="Aucun artiste contact\u00e9"
            footerLabel="Total des contacts"
            icon={MdContactPhone}
        />
    );
}

export default BookingContactList;
